// TableEquiposSinMovimiento.tsx

import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetEquiposSinMovimiento } from "@/shared/actions/erp/reportes/equipos-sin-movimiento.actions";
import { useTableColumnsEquiposSinMovimiento } from "../../hooks";
import { useMemo } from "react";
import { EquiposSinMovimiento } from "../../types/equipos-sin-movimiento.interface";

interface Props {
  fechaDesdeApplied: string;
  fechaHastaApplied: string;
}

export default function TableEquiposSinMovimiento({ fechaDesdeApplied, fechaHastaApplied }: Props) {

  // hook
  const {
    pagination,
    setPagination
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    columns
  } = useTableColumnsEquiposSinMovimiento()

  const filtersWithDateRange = useMemo(() => {
    return {
      ...filterObject,
      ...(fechaDesdeApplied ? { fecha_desde: fechaDesdeApplied } : {}),
      ...(fechaHastaApplied ? { fecha_hasta: fechaHastaApplied } : {}),
    };
  }, [fechaDesdeApplied, fechaHastaApplied, filterObject]);

  // fetch
  const {
    isLoading,
    data,
    isRefetching
  } = useFetchGetEquiposSinMovimiento({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filtersWithDateRange
    }
  });

  const tableData: EquiposSinMovimiento[] = data?.data ?? [];

  const totalRows = data?.total ?? tableData.length;

  return <>
    <GeneralTable<EquiposSinMovimiento>
      columns={columns}
      data={tableData}
      isLoading={isLoading}
      isRefetching={isRefetching}
      // search
      enableGlobalFilter={false}
      // filters
      enableManualFiltering={true}
      columnFilters={columnFilters}
      onColumnFiltersChange={setColumnFilters}
      // pagination
      pagination={pagination}
      onPaging={setPagination}
      rowCount={totalRows}
      // actions
      enableColumnActions={false}
      enableEditing={false}
    />

  </>
}
